<template>
    <div>
        <CCardBody>
            <div class="text-right btngroup">

              <CRow class="mb-4">
                <CCol class="col-6">

                </CCol>
                <CCol class="col-6">
                  <CButton @click="deleteCategory(0)"
                           class="deleteBtn"
                  >
                    Delete
                  </CButton>
                  <CButton
                      class="addBtn"
                      @click="showModal"
                  >
                    Create
                  </CButton>
                </CCol>
              </CRow>

            </div>
            <search-items v-model="search" :searchHandler="updateTable"></search-items>
<!--            <search-->
<!--                float='right'-->
<!--                :clickHandler="updateTable"-->
<!--                placeholder="Type to search"-->
<!--            />-->
            <b-table
                :items="categories"
                :fields="headers"
                sorter
                >
              <template  #cell(id)="{item}">
                <b-form-checkbox
                    :id="'checkbox_'+item.id"
                    v-model="checkbox"
                    name="checkbox-1"
                    :value="item.id"
                    unchecked-value="not_accepted"
                >
                </b-form-checkbox>
              </template>
                <template #cell(image_url)="item" >
                  <img v-if="item.item.image_url" class="cat_image" :src="base_url+'/'+item.item.image_url">
                  <img v-else-if="item.item.icon_name" class="cat_image" :src="getIconSrc(availableIcons[item.item.icon_name])">
                </template>
                <template #cell(actions)="item">
                  <edit class="delete_step ml-2" @click="editCategory(item.item)" fillColor="#009FE3" />
                  <delete class="delete_step ml-2" @click="deleteCategory(item.item.id)" fillColor="#E30000" />
<!--                  <template v-if="$can('sort-category')">-->
                    <!-- Reordering operates on the complete ordered set, so the arrows are only
                         disabled at the global first/last position, not at each page boundary. -->
                    <button class="btn btn-primary btn-sm mr-2" :id="item.item.id"
                            @click.prevent="swapCategories('up', item.index, false)"
                            :disabled="pagination.currentPage === 1 && item.index === 0"
                    ><b-icon-arrow-up-short style="font-size: 28px" /></button>
                    <button class="btn btn-primary btn-sm mr-2" :id="item.item.id"
                            @click.prevent="swapCategories('down', item.index, false)"
                            :disabled="pagination.currentPage === pagination.lastPage && item.index === (categories.length - 1)"
                    ><b-icon-arrow-down-short style="font-size: 28px" /></button>
<!--                  </template>-->
                </template>
              <template #cell(show_subCategories)="row">
                <template v-if="row.item.subcategories.length > 0">
                  <b-button variant="primary" @click="row.toggleDetails">Show Sub-Categories</b-button>
                </template>
              </template>
              <template #row-details="item">
                <table class="w-100 bg-gray-100">
                  <tbody>
                    <template v-for="(subCategory, subCategory_index) in item.item.subcategories">
                      <tr :key="`sub_category-${subCategory_index}`">
                        <td>
                          <b-form-checkbox
                              :id="'checkbox_'+subCategory.id"
                              v-model="checkbox"
                              name="checkbox-1"
                              :value="subCategory.id"
                              unchecked-value="not_accepted"
                          >
                          </b-form-checkbox>
                        </td>
                        <td>{{ subCategory.category_name }}</td>
                        <td>
                          <img v-if="subCategory.image_url" class="cat_image" :src="base_url+'/'+subCategory.image_url">
                          <img v-else-if="subCategory.icon_name" class="cat_image" :src="getIconSrc(availableIcons[subCategory.icon_name])">
                        </td>
                        <td>
                          <edit class="delete_step ml-2" @click="editCategory(subCategory)" fillColor="#009FE3" />
                          <delete class="delete_step ml-2" @click="deleteCategory(subCategory.id)" fillColor="#E30000" />
                          <!-- Subcategories are not paginated, so disable at the first/last subcategory. -->
                          <button class="btn btn-primary btn-sm mr-2" :id="subCategory.id"
                                  @click.prevent="swapCategories('up', subCategory_index, item.item.id)"
                                  :disabled="subCategory_index === 0"
                          ><b-icon-arrow-up-short style="font-size: 28px" /></button>
                          <button class="btn btn-primary btn-sm mr-2" :id="subCategory.id"
                                  @click.prevent="swapCategories('down', subCategory_index, item.item.id)"
                                  :disabled="subCategory_index === (item.item.subcategories.length - 1)"
                          ><b-icon-arrow-down-short style="font-size: 28px" /></button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </template>
            </b-table>
          <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              aria-controls="itemList"
              align="center"
              @change="handlePagination"
              v-if="pagination.total > 0"
              :key="pagination.currentPage"
          ></b-pagination>
            <b-modal @hide="resetForm" id="categoryModal" size="md" no-close-on-backdrop hide-footer>
                <template #modal-title>
                    <span>Add new category</span>
                </template>

                <CRow>
                    <CCol class="col-md-12">
                      <label for="category_name">Category Name</label>
                        <CInput
                        type="text"
                        name="name"
                        v-model="name"
                        v-validate="{required: true}"
                        placeholder="Category name"
                        id="category_name"
                        >
                        </CInput>
                        <div v-if="errors && errors.first('name')" class="error_msg">
                            Category name is required
                        </div>
                    </CCol>
                </CRow>
                <CRow style="margin-top:10px ">
                    <CCol class="col-md-12">
                      <label for="category_icon_selector">
                        <strong>Category Icon</strong> 
                        <small class="text-muted">(Recommended: Select from list below)</small>
                      </label>
                      <CInput
                        type="text"
                        v-model="iconSearch"
                        placeholder="Search icons..."
                        class="mb-2"
                        style="margin-top: 8px;"
                      >
                      </CInput>
                      <div class="icon-selector-container mb-3" style="max-height: 300px; overflow-y: auto; border: 1px solid #ddd; padding: 15px; border-radius: 4px; background-color: #f8f9fa;">
                        <div class="row">
                          <div 
                            v-for="(iconPath, iconName) in filteredIcons" 
                            :key="iconName"
                            class="col-2 mb-2"
                            style="cursor: pointer;"
                            @click="selectIcon(iconName)"
                            :title="iconName.replace('Icon', '')"
                          >
                            <div 
                              class="icon-item text-center p-2"
                              :class="{'icon-selected': selectedIcon === iconName}"
                              style="border: 2px solid transparent; border-radius: 4px; transition: all 0.2s;"
                              :style="selectedIcon === iconName ? 'border-color: #009FE3; background-color: #e3f2fd;' : ''"
                            >
                              <img 
                                :src="getIconSrc(iconPath)" 
                                :alt="iconName"
                                style=" object-fit: contain;"
                              />
                              <div 
                                class="mt-1 icon-name" 
                                style="font-size: 10px;"
                              >
                                {{ iconName.replace('Icon', '') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="selectedIcon" class="mb-2">
                        <small class="text-success">
                          <strong>Selected:</strong> {{ selectedIcon.replace('Icon', '') }}
                        </small>
                        <CButton 
                          size="sm" 
                          color="secondary" 
                          class="ml-2"
                          @click="clearIconSelection"
                        >
                          Clear Selection
                        </CButton>
                      </div>
                      <label for="category_icon_upload" class="mt-2">
                        <strong>Or Upload Custom Icon</strong>
                      </label>
                      <b-form-file
                          v-model="file"
                          accept=".jpeg, .png, .jpg, .svg"
                          name="file"
                          placeholder="Choose a file or drop it here..."
                          drop-placeholder="Drop file here..."
                          @input="clearIconOnFileUpload"
                      ></b-form-file>
                      <div v-if="errors && errors.first('file')" class="error_msg">
                        {{ errors.first('file') }}
                      </div>
                    </CCol>

                  </CRow>
              <CRow style="margin-top:10px ">
                <CCol class="col-md-12">
                  <label for="category_name">Category Parent</label>
                  <v-select
                    aria-label="Select category parent"
                    placeholder="Select Parent"
                    :options="parentOptions()"
                    label="category_name"
                    v-model="selectedParent"
                  >
                  </v-select>
                </CCol>
              </CRow>
                <CRow style="margin-top:10px ">
                  <CCol class="col-md-12">

                    <b-form-checkbox
                        :id="'searchable'"
                        v-model="searchable"
                        name="searchable"

                    >
                      <label for="searchable">Searchable</label>
                    </b-form-checkbox>

                  </CCol>
                  <CCol class="col-12 text-right" style="margin-top:10px ">
                    <CButton
                        color="success"
                        class="mt-2 float-right"
                        @click="saveCategory"
                    >
                      Save
                    </CButton>
                  </CCol>
                </CRow>
            </b-modal>
            <b-modal @hide="resetForm" id="editCategory" size="md" no-close-on-backdrop  hide-footer>
                <template #modal-title>
                    <span>Update category</span>
                </template>

              <CRow>
                <CCol class="col-md-12">
                  <label for="category_name">Category Name</label>
                   <CInput
                        type="text"
                        name="name"
                        v-model="name"
                        v-validate="{required: true}"
                        placeholder="Category name"
                        >
                        </CInput>
                        <div v-if="errors && errors.first('name')" class="error_msg">
                            Category name is required
                        </div>
                  </CCol>
              </CRow>
              <CRow style="margin-top:10px ">
                  <CCol class="col-md-12">
                    <label for="category_icon_selector_edit">
                      <strong>Category Icon</strong> 
                      <small class="text-muted">(Recommended: Select from list below)</small>
                    </label>
                    <CInput
                      type="text"
                      v-model="iconSearch"
                      placeholder="Search icons..."
                      class="mb-2"
                      style="margin-top: 8px;"
                    >
                    </CInput>
                    <div class="icon-selector-container mb-3" style="max-height: 300px; overflow-y: auto; border: 1px solid #ddd; padding: 15px; border-radius: 4px; background-color: #f8f9fa;">
                      <div class="row">
                        <div 
                          v-for="(iconPath, iconName) in filteredIcons" 
                          :key="iconName"
                          class="col-2 mb-2"
                          style="cursor: pointer;"
                          @click="selectIcon(iconName)"
                          :title="iconName.replace('Icon', '')"
                        >
                          <div 
                            class="icon-item text-center p-2"
                            :class="{'icon-selected': selectedIcon === iconName}"
                            style="border: 2px solid transparent; border-radius: 4px; transition: all 0.2s;"
                            :style="selectedIcon === iconName ? 'border-color: #009FE3; background-color: #e3f2fd;' : ''"
                          >
                            <img 
                              :src="require(`@/icons/flex-flat/${iconPath.split('/').pop()}`)" 
                              :alt="iconName"
                              style=" object-fit: contain;"
                            />
                            <div 
                              class="mt-1 icon-name" 
                              style="font-size: 10px;"
                            >
                              {{ iconName.replace('Icon', '') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="selectedIcon" class="mb-2">
                      <small class="text-success">
                        <strong>Selected:</strong> {{ selectedIcon.replace('Icon', '') }}
                      </small>
                      <CButton 
                        size="sm" 
                        color="secondary" 
                        class="ml-2"
                        @click="clearIconSelection"
                      >
                        Clear Selection
                      </CButton>
                    </div>
                    <label for="category_icon_upload_edit" class="mt-2">
                      <strong>Or Upload Custom Icon</strong>
                    </label>
                    <b-form-file
                        v-model="file"
                        accept=".jpeg, .png, .jpg, .svg"
                        name="file"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        @input="clearIconOnFileUpload"
                    ></b-form-file>
                    <div v-if="file_url && file_url.length > 0" style="margin-top:10px ">
                      <label>Current uploaded image</label>
                      <img class="cat_upload_image" :src="file_url" >
                    </div>
                  </CCol>
              </CRow>
              <CRow style="margin-top:10px ">
                <CCol class="col-md-12">
                  <label for="category_name">Category Parent</label>
                  <v-select
                      aria-label="Select category parent"
                      placeholder="Select Parent"
                      :options="parentOptions(category_id)"
                      label="category_name"
                      v-model="selectedParent"
                  >
                  </v-select>
                </CCol>
              </CRow>
              <CRow style="margin-top:10px ">
                <CCol class="col-md-12">

                  <b-form-checkbox
                      :id="'searchable'"
                      v-model="searchable"
                      name="searchable"

                  >
                    <label for="searchable">Searchable</label>
                  </b-form-checkbox>

                </CCol>
                <CCol class="col-12 text-right" style="margin-top:10px ">
                  <CButton
                      color="success"
                      class="mt-2 float-right"
                      @click="updateCategory"
                  >
                    Save
                  </CButton>
                </CCol>
              </CRow>

            </b-modal>
        </CCardBody>
    </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete.vue';
import Edit from 'vue-material-design-icons/Pencil.vue';
// import Search from '@/components/Search.vue';
import { http } from "@/config/httpCommon"
import SearchItems from "../../components/SearchItems";
import {getPageModal, removePageModal, setPageModal, getPreviousPage, getLastPage} from "@/helpers/Helpers";
import { flexFlatCategories } from "@/icons/flex-flat-categories";

export default {
    components:{
        Delete,
        Edit,
        SearchItems,
    },
    data () {
        return {
            stepModal: false,
            category_id: 0,
            name: '',
            file_url: '',
            file: null,
            searchable:false,
            selectedIcon: null,
            availableIcons: flexFlatCategories,
            iconSearch: '',
            headers: [
                {key: 'id', label: '', sorter: false},
                {key: 'category_name', label: 'Name',},
                {key: 'image_url', label: 'Icon',},
                {key: 'actions', label: 'Actions',},
                {key: 'show_subCategories', label: '',},
            ],
            categories: [],
            // Complete, ordered set of top-level categories across all pages. Used for
            // cross-page reordering and the parent selector so neither is limited to the
            // currently displayed page.
            allCategories: [],
            base_url: process.env.VUE_APP_FILE_URL,
          pagination:{
            rows:null,
            currentPage:null,
            perPage:null,
            total:0,
            lastPage:null
          },
          search:'',
          checkbox: [],
          selectedParent: null
        }
    },
    computed: {
      filteredIcons() {
        if (!this.iconSearch || this.iconSearch.trim() === '') {
          return this.availableIcons;
        }
        const searchTerm = this.iconSearch.toLowerCase().trim();
        const filtered = {};
        for (const [iconName, iconPath] of Object.entries(this.availableIcons)) {
          const displayName = iconName.replace('Icon', '').toLowerCase();
          if (displayName.includes(searchTerm)) {
            filtered[iconName] = iconPath;
          }
        }
        return filtered;
      }
    },
    async created(){
      this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getCategories)
      this.loadAllCategories();
      this.selectedParent = null;
    },
    methods: {
      async swapCategories(action, swap_category_index, parent) {
        let self = this;

        let query_params = "";
        let swap_category, swap_with_category;

        if (parent) {
          // Subcategories are loaded in full (they are not paginated), so the swap partner
          // always exists within the parent's subcategory list.
          let parentCategory = self.categories.find(cat => cat.id === parent);
          if (!parentCategory || !parentCategory.subcategories) return;

          let subcategories = parentCategory.subcategories;
          swap_category = subcategories[swap_category_index];
          let swap_with_index = action === "up" ? swap_category_index - 1 : swap_category_index + 1;
          swap_with_category = subcategories[swap_with_index] || null;
          if (!swap_category || !swap_with_category) return; // at a boundary, nothing to swap

          query_params = `?swap_category_id=${swap_category.id}&swap_sort_order=${swap_category.sort_order}`;
          query_params += `&swap_with_category_id=${swap_with_category.id}&swap_with_sort_order=${swap_with_category.sort_order}`;
          query_params += `&action=${action}&parent=${parent}`;
          if (self.search) {
            query_params += `&search=${self.search}`;
          }
          query_params += `&page=${self.pagination.currentPage}`;

          await self.getCategories(query_params);
          await self.loadAllCategories();
          return;
        }

        // Top-level categories: resolve the swap partner from the COMPLETE ordered set rather
        // than the current page slice, so a category can move across page boundaries.
        swap_category = self.categories[swap_category_index];
        if (!swap_category) return;

        // When a search filter is active the displayed list is already the relevant set.
        let orderedSet = (self.search || !self.allCategories.length) ? self.categories : self.allCategories;
        let globalIndex = orderedSet.findIndex(cat => cat.id === swap_category.id);
        if (globalIndex === -1) return;

        let swap_with_global_index = action === "up" ? globalIndex - 1 : globalIndex + 1;
        swap_with_category = orderedSet[swap_with_global_index] || null;
        if (!swap_with_category) return; // already the first/last category overall

        query_params = `?swap_category_id=${swap_category.id}&swap_sort_order=${swap_category.sort_order}`;
        query_params += `&swap_with_category_id=${swap_with_category.id}&swap_with_sort_order=${swap_with_category.sort_order}`;
        query_params += `&action=${action}`;
        if (self.search) {
          query_params += `&search=${self.search}`;
        }

        // Follow the moved category to the page it now lands on so the view reflects the change.
        let perPage = self.pagination.perPage || 10;
        let targetPage = self.search
          ? self.pagination.currentPage
          : (Math.floor(swap_with_global_index / perPage) + 1);
        query_params += `&page=${targetPage}`;

        await self.getCategories(query_params);
        await self.loadAllCategories();
      },
      async getCategories(payload) {
        let res = await this.$store.dispatch("getCategories", payload);
        this.categories = this.$store.getters.getCategories;
        this.makePagination(res.data.meta);
      },
      // Fetch every page of top-level categories so reordering and the parent selector can
      // operate on the merchant's full category set, not just the visible page.
      async loadAllCategories() {
        try {
          let all = [];
          let page = 1;
          let lastPage = 1;
          do {
            let res = await http.get(`category?page=${page}`);
            all = all.concat(res.data.data || []);
            lastPage = (res.data.meta && res.data.meta.last_page) ? res.data.meta.last_page : 1;
            page++;
          } while (page <= lastPage);
          this.allCategories = all;
        } catch (err) {
          console.log("loadAllCategories error", err);
        }
      },
      // Eligible parents = every top-level category except the one being edited and its own
      // subcategories (prevents a category from becoming its own ancestor).
      parentOptions(excludeId = null) {
        if (!excludeId) {
          return this.allCategories;
        }
        const excluded = new Set([excludeId]);
        const target = this.allCategories.find(cat => cat.id === excludeId);
        if (target && target.subcategories) {
          target.subcategories.forEach(sub => excluded.add(sub.id));
        }
        return this.allCategories.filter(cat => !excluded.has(cat.id));
      },
      makePagination(data){
        this.pagination.currentPage = data.current_page;
        this.pagination.rows = data.total;
        this.pagination.perPage = data.per_page;
        this.pagination.total = data.total;
        this.pagination.lastPage = data.last_page;
      },
      /*changeFactory(obj){
        let params = '?search='+this.search+'&factory_id='+obj.value;
        this.getCategories(params);
      },*/
      editCategory(item){
        const selectedCategory = this.categories.find((category) => category.id === item.parent_id);
        this.selectedParent = item.parent_id ? selectedCategory : null;
        this.category_id = item.id;
        this.name = item.category_name;
        this.file_url = this.base_url+'/'+item.image_url;
        this.searchable = (item.searchable == 1) ? true : false;
        this.selectedIcon = item.icon_name || null;
        this.$bvModal.show("editCategory");
      },
        showModal(){
            this.$bvModal.show("categoryModal");
        },
      async updateCategory(){
        let valid = await this.$validator.validate();
        if(valid){
          this.$store.commit('set', ['showLoader', true]);
          try{
            let formData = new FormData();

            formData.append('name', this.name);
            formData.append('file', this.file);
            formData.append('searchable', this.searchable ? 1 : 0);
            formData.append('_method', 'PUT')
            if (this.selectedParent) {
              formData.append('parent_id', this.selectedParent.id);
            }
            if (this.selectedIcon) {
              formData.append('icon_name', this.selectedIcon);
            }
            await this.$store.dispatch("updateCategory", {data: formData, id: this.category_id});
            this.getCategories('?page=1');
            this.$bvModal.hide("editCategory");
            this.categories = this.$store.getters.getCategories;
            this.preservePagination( 'page', 'search', this.$route.name, this.getCategories)
            this.loadAllCategories();
            this.$store.commit('set', ['showLoader', false]);
            this.showToast('Category updated successfully', 'SUCCESS');
          }catch(err){
            this.$store.commit('set', ['showLoader', false]);
            this.showError(err);
            console.log("err", err);
          }
        }
      },
        async saveCategory(){
            let valid = await this.$validator.validate();
            if(valid){
              this.$store.commit('set', ['showLoader', true]);
              let formData = new FormData();

              formData.append('name', this.name);
              formData.append('file', this.file);
              formData.append('searchable', this.searchable ? 1 : 0);
              if (this.selectedParent) {
                formData.append('parent_id', this.selectedParent.id);
              }
              if (this.selectedIcon) {
                formData.append('icon_name', this.selectedIcon);
              }
              http.post(`category`, formData).then(() => {
                this.categories = this.$store.getters.getCategories;
                this.nextPageOnCreation('page','search', this.categories.length, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage ,this.pagination.total ), this.$route.name, this.getCategories);
                this.$bvModal.hide("categoryModal");
                this.loadAllCategories();
                this.$store.commit('set', ['showLoader', false]);
                this.showToast('Category added successfully', 'SUCCESS');
              }).catch(error => {
                this.$store.commit('set', ['showLoader', false]);
                this.showError(error)
                console.log("error saving category", error);
              });
            }
            this.selectedParent = null;
        },
        async deleteCategory(id = 0){
            try{
              if (id !=0){
                this.checkbox = []
                this.checkbox.push(id)
              }
              if (this.checkbox.length > 0){
                await this.$store.dispatch("deleteCategory", this.checkbox);
                this.categories = this.$store.getters.getCategories;
                this.previousPageOnDeletion('page', 'search', this.categories.length, this.$route.name, this.getCategories);
                this.loadAllCategories();
                this.checkbox = [];

                this.showToast('Category deleted successfully', 'SUCCESS');
              }else{
                this.showToast('Please select category', 'ERROR')
              }
            }catch(err){
                console.log("Errror", err)
            }
        },
        async updateTable(){
          try{
            this.$store.commit('set', ['showLoader', true]);
            let params = '?search='+this.search;
            setPageModal(1,this.$route.name,this.search);
            this.getCategories(params);
            this.$store.commit('set', ['showLoader', false]);
          }catch(err){
            this.$store.commit('set', ['showLoader', false]);
            console.log(err)
          }
        },
      handlePagination(page=''){
        let params = '?page='+page;
        setPageModal(page,this.$route.name,this.search);
        if(this.search) {
          params += '&search='+this.search
        }
        this.getCategories(params);
      },
      resetForm(){
        this.name = ''
        this.file = null
        this.selectedIcon = null
        this.file_url = ''
        this.iconSearch = ''
      },
      selectIcon(iconName){
        this.selectedIcon = iconName;
        // Clear file when icon is selected to avoid confusion
        this.file = null;
      },
      clearIconSelection(){
        this.selectedIcon = null;
      },
      clearIconOnFileUpload(){
        // Clear icon selection when file is uploaded
        if(this.file) {
          this.selectedIcon = null;
        }
      },
      getIconSrc(iconPath){
        // Extract filename from path like '@/icons/flex-flat/address-book-icon.svg'
        const filename = iconPath.split('/').pop();
        // Use require with explicit path - webpack will handle this at build time
        // Create a mapping to avoid dynamic require issues
        const iconMap = {
          'address-book-icon.svg': require('@/icons/flex-flat/address-book-icon.svg'),
          'backpack.svg': require('@/icons/flex-flat/backpack.svg'),
          'ball.svg': require('@/icons/flex-flat/ball.svg'),
          'baseball.svg': require('@/icons/flex-flat/baseball.svg'),
          'bicycle-bike.svg': require('@/icons/flex-flat/bicycle-bike.svg'),
          'boots.svg': require('@/icons/flex-flat/boots.svg'),
          'brightness.svg': require('@/icons/flex-flat/brightness.svg'),
          'cap-front.svg': require('@/icons/flex-flat/cap-front.svg'),
          'cap-side.svg': require('@/icons/flex-flat/cap-side.svg'),
          'cricket.svg': require('@/icons/flex-flat/cricket.svg'),
          'cycling.svg': require('@/icons/flex-flat/cycling.svg'),
          'downhill-skiing.svg': require('@/icons/flex-flat/downhill-skiing.svg'),
          'dribble-logo.svg': require('@/icons/flex-flat/dribble-logo.svg'),
          'fishing-phishing.svg': require('@/icons/flex-flat/fishing-phishing.svg'),
          'flag-score.svg': require('@/icons/flex-flat/flag-score.svg'),
          'football.svg': require('@/icons/flex-flat/football.svg'),
          'golf.svg': require('@/icons/flex-flat/golf.svg'),
          'gymnastics.svg': require('@/icons/flex-flat/gymnastics.svg'),
          'hanger.svg': require('@/icons/flex-flat/hanger.svg'),
          'hiking.svg': require('@/icons/flex-flat/hiking.svg'),
          'hockey.svg': require('@/icons/flex-flat/hockey.svg'),
          'holiday-vacation-beach-umbrella.svg': require('@/icons/flex-flat/holiday-vacation-beach-umbrella.svg'),
          'ice-skating.svg': require('@/icons/flex-flat/ice-skating.svg'),
          'kayaking.svg': require('@/icons/flex-flat/kayaking.svg'),
          'leaf.svg': require('@/icons/flex-flat/leaf.svg'),
          'martial-arts.svg': require('@/icons/flex-flat/martial-arts.svg'),
          'meditation.svg': require('@/icons/flex-flat/meditation.svg'),
          'module-three.svg': require('@/icons/flex-flat/module-three.svg'),
          'motorsports-helmet.svg': require('@/icons/flex-flat/motorsports-helmet.svg'),
          'nordic-walking.svg': require('@/icons/flex-flat/nordic-walking.svg'),
          'notification-icon.svg': require('@/icons/flex-flat/notification-icon.svg'),
          'orders-icon.svg': require('@/icons/flex-flat/orders-icon.svg'),
          'paint-palette.svg': require('@/icons/flex-flat/paint-palette.svg'),
          'playground.svg': require('@/icons/flex-flat/playground.svg'),
          'potted-flower-tulip.svg': require('@/icons/flex-flat/potted-flower-tulip.svg'),
          'roller-skating.svg': require('@/icons/flex-flat/roller-skating.svg'),
          'running.svg': require('@/icons/flex-flat/running.svg'),
          'scuba-diving.svg': require('@/icons/flex-flat/scuba-diving.svg'),
          'settings-icon.svg': require('@/icons/flex-flat/settings-icon.svg'),
          'shirt.svg': require('@/icons/flex-flat/shirt.svg'),
          'shopping-bag-hand-bag.svg': require('@/icons/flex-flat/shopping-bag-hand-bag.svg'),
          'shorts.svg': require('@/icons/flex-flat/shorts.svg'),
          'skateboarding.svg': require('@/icons/flex-flat/skateboarding.svg'),
          'sledding.svg': require('@/icons/flex-flat/sledding.svg'),
          'snow-flake.svg': require('@/icons/flex-flat/snow-flake.svg'),
          'snowboarding.svg': require('@/icons/flex-flat/snowboarding.svg'),
          'soccer.svg': require('@/icons/flex-flat/soccer.svg'),
          'sock.svg': require('@/icons/flex-flat/sock.svg'),
          'sprint.svg': require('@/icons/flex-flat/sprint.svg'),
          'stadium.svg': require('@/icons/flex-flat/stadium.svg'),
          'surfing.svg': require('@/icons/flex-flat/surfing.svg'),
          'swimming.svg': require('@/icons/flex-flat/swimming.svg'),
          'tennis.svg': require('@/icons/flex-flat/tennis.svg'),
          'user-circle.svg': require('@/icons/flex-flat/user-circle.svg'),
          'volleyball.svg': require('@/icons/flex-flat/volleyball.svg'),
          'walking-steps.svg': require('@/icons/flex-flat/walking-steps.svg'),
          'whistle.svg': require('@/icons/flex-flat/whistle.svg'),
        };
        return iconMap[filename] || '';
      }
    },
}
</script>
<style type="scss">
    .delete_step{
        cursor: pointer;
    }
    .cat_image{
      width: 100%;
      max-width: 20px;
    }
    .icon-item {
      transition: all 0.2s ease;
    }
    .icon-item:hover {
      background-color: #f0f0f0 !important;
      transform: scale(1.05);
    }
    .icon-selected {
      border-color: #009FE3 !important;
      background-color: #e3f2fd !important;
    }
    .icon-selector-container {
      scrollbar-width: thin;
      scrollbar-color: #ccc #f8f9fa;
    }
    .icon-selector-container::-webkit-scrollbar {
      width: 8px;
    }
    .icon-selector-container::-webkit-scrollbar-track {
      background: #f8f9fa;
    }
    .icon-selector-container::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }
    .icon-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
      cursor: default;
    }
</style>